export default __webpack_public_path__ + "static/media/Yoni-M.fcd2b0bd.jpg";